import React, { ReactNode } from 'react';

import '../../base.css';

type Props = {
  children?: ReactNode;
};
const TableHeadersTop = ({ children }: Props) => {
  return <div className="table-headers-top">{children}</div>;
};

export default TableHeadersTop;
